import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import {
  MitsNumberBoxValueAccessorDirective
} from './mits-number-box-value-accessor.directive';
import { MitsNumberBoxComponent } from './mits-number-box.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule],
  declarations: [MitsNumberBoxComponent, MitsNumberBoxValueAccessorDirective],
  exports: [MitsNumberBoxComponent, MitsNumberBoxValueAccessorDirective],
  providers: [],
})
export class MitsNumberBoxModule {
}
